export const graphic_decoration = [
  { char: '➰', name: 'Curly Loop', nameZh: '線條裝飾', keywords: ['line', 'deco', 'style'] },
  { char: '〰️', name: 'Wavy Dash', nameZh: '波浪分隔', keywords: ['wave', 'split', 'line'], hot: true },
  { char: '✨', name: 'Sparkles', nameZh: '夢幻點綴', keywords: ['magic', 'shine', 'deco'], hot: true },
  { char: '💫', name: 'Dizzy', nameZh: '動態感', keywords: ['spin', 'star', 'energy'] },
  { char: '💠', name: 'Diamond', nameZh: '幾何菱形', keywords: ['shape', 'blue', 'deco'] },
  { char: '🫧', name: 'Bubbles', nameZh: '輕盈氣泡', keywords: ['dream', 'air', 'clean'] },
  { char: '💢', name: 'Anger', nameZh: '張力符號', keywords: ['bang', 'anime', 'sharp'] },
  { char: '💥', name: 'Collision', nameZh: '亮點爆發', keywords: ['boom', 'hit', 'focus'], hot: true },
  { char: '🌀', name: 'Cyclone', nameZh: '旋渦/深度', keywords: ['deep', 'spin', 'blue'] },
  { char: '🕳️', name: 'Hole', nameZh: '細節黑洞', keywords: ['dark', 'deep', 'hide'] },
  { char: '💤', name: 'Zzz', nameZh: '放鬆符號', keywords: ['sleep', 'off', 'chill'] },
  { char: '💨', name: 'Dash', nameZh: '速度感', keywords: ['fast', 'run', 'quick'] },
];